<template>
  <div class="module-box" :style="{ height: height, width: width }">
    <div v-if="showChart" :id="id" class="chart-box" />
    <div v-else class="no-data">暂无数据</div>
  </div>
</template>
<script>
import echarts from "echarts";
import resize from "./mixins/resize";
export default {
  name: "FszPie",
  mixins: [resize],
  props: {
    sexData: {
      type: Array,
    },
    data: {
      default() {
        return {
          chartPieData: [
            {
              name: "饼图",
              color: "#3186FF",
              data: [120, 132, 101, 134, 90, 230, 210],
            },
          ],
        };
      },
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    pieTitle: {
      type: Object,
      default: function () {
        return { title: "" };
      },
    },
  },
  data() {
    return {
      chart: null,
      showChart: true,
      option: {
        color: ["#4B84FF", "#28D4E5", "#FF627F"],
        // title: {
        //   text: this.pieTitle.title,
        //   textStyle: {
        //     color: '#222222',
        //     fontSize: 14,
        //     lineHeight: 20
        //   },
        //   left: 0,
        //   top: 0
        // },
        // tooltip: {
        //   show: false,
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b} : {c} ({d}%)',
        //   backgroundColor: 'rgba(255,255,255,0.9)',
        //   textStyle: {
        //     fontSize: 12,
        //     color: '#7D7D7D',
        //     lineHeight: 20
        //   },
        //   padding: 12
        // },
        legend: {
          right: 0,
          icon: "circle",
          data: [],
          align: "left",
          itemWidth: 6,
          itemHeight: 6,
          itemHeight: "5",
          itemGap: 40,
          bottom: "20%",
          orient: "horizontal",
          verticalAlign: "right",
          left: "center",
          textStyle: {
            fontSize: 13,
            color: "#9095A7",
            fontWeight: 400,
            lineHeight: 20,
          },
          formatter: (name, value) => {
            let data = this.data.chartPieData;
            let val;
            data.forEach((el) => {
              for (var i = 0; i < el.data.length; i++) {
                if (el.data[i].name == name) {
                  val = el.data[i].value;
                }
              }
            });
            var arr = ["{a|" + name + "}", "{b|" + val + "}"];
            return arr.join("\n");
          },
        },

        // dataZoom: [
        //     {
        //         show: true,
        //         start: 94,
        //         end: 100
        //     },
        //     {
        //         type: 'inside',
        //         start: 94,
        //         end: 100
        //     },
        //     {
        //         show: true,
        //         yAxisIndex: 0,
        //         filterMode: 'empty',
        //         width: 30,
        //         height: '80%',
        //         showDataShadow: false,
        //         left: '93%'
        //     }
        // ],
        series: [],
        title: {},
      },
    };
  },
  computed: {
    id() {
      return (
        "pieChart" + new Date().getTime() + Math.round(Math.random() * 100)
      );
    },
  },
  created() {},
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        console.log("newVal：", newVal);
        console.log("reload line chart");
        if (newVal.chartPieData.length) {
          this.showChart = true;
          this.initChart();
        } else {
          this.showChart = false;
        }
      },
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart()
    // })
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.option.series = this.keyParams().series;
      this.option.legend.data = this.keyParams().legend;
      console.log(this.option.legend.data);
      if (this.option.legend.data.length > 1) {
        this.option.legend.show = true;
      }
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option, true);
    },

    keyParams() {
      const p = {
        legend: [],
        series: [],
        color: [],
      };
      this.data.chartPieData.forEach((el) => {
        this.option.title = el.title;
        p.color.push(el.color),
          el.data.forEach((element) => {
            // console.log(el.data)
            for (let index = 0; index < el.data.length; index++) {
              // console.log(el.data[index].value)
              p.legend.push({
                name: el.data[index].name,
                // name: ,
                // selectedMode:true,//取消图例上的点击事件
                // textStyle: {
                //   color: '#666666'
                // },
                orient: "vertical",
                left: "left",
                textStyle: {
                  lineHeight: 0,
                  rich: {
                    a: {
                      fontSize: 13,

                      align: "left",
                      padding: [0, 0, 0, 0],
                    },
                    b: {
                      fontSize: 18,
                      align: "left",

                      padding: [-40, 0, 0, 0],
                      // lineHeight:25,
                      color: "#2F354D",
                      fontWeight: 600,
                    },
                  },
                },
              });
            }
          });
        // console.log(el);
        p.series.push({
          type: "pie",
          name: el.name,
          top: "-20px",
          radius: ["40%", "50%"],
          center: ["50%", "40%"],
          // label: {
          //   normal: {
          //     position: 'outsideFill',
          //     show: true
          //   }
          // },
          labelLine: {
            show: false,
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
            normal: {
              label: {
                show: true,
                formatter: function (params) {
                  if (params.percent == 0) {
                    return "";
                  }
                  let str = params.percent + "%";
                  return str;
                },
                fontSize: 14,
                padding: -20,
              },
              labelLine: { show: false },
            },
          },
          data: el.data,
        });
      });
      return p;
    },
    delPositiveLable(val) {
      return val.toString().replace(/\-/, "");
    },
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
}

.module-box {
  position: relative;
}

.chart-box {
  position: relative;
  height: 100%;
}

.no-data {
  font-size: 14px;
  font-family: @family;
  font-weight: 400;
  color: rgba(111, 111, 111, 1);
  line-height: 20px;
}
</style>
